import { Box } from '@dixa/lib-shared-habla';

import { AiLoadingState } from 'components/aiLoadingState';

type UIBlockerLoadingProps = {
  loadingText: string;
};

export const UIBlockerLoading = ({
  loadingText,
}: UIBlockerLoadingProps): JSX.Element => (
  <Box style={{ position: 'absolute', bottom: 16 }}>
    <AiLoadingState label={loadingText} />
  </Box>
);
